<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <!-- <router-view /> -->
    <!--页面返回不刷新-->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <tabbar v-if="$route.meta.showTab"></tabbar>
  </div>

</template>

<script>
// import Watermark from './assets/js/waterMark'; //路径不要写错
import tabbar from "./components/common/tabbar.vue";
export default {
  name: "App",
  components: {
    tabbar,
  },
  data() {
    return {
      userName: ''
    }
  },
  // mounted: function () {
  //   this.userName = JSON.parse(localStorage.getItem('userInfo')).userName
  //   Watermark.set(this.userName)
  // }

};

</script>

<style>
@import "./assets/css/main.css";

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}

.van-dialog__message {
  font-size: 1rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #108ee9;
}

.van-overlay {
  background-color: rgba(0, 0, 0, 0.49) !important;
}
body {
  background-color: #f5f7f9;
}
</style>



// WEBPACK FOOTER //
// src/App.vue